import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Link} from 'react-router-dom';
import {Container} from 'react-bootstrap';
import BrandsList from './brands-list';
import ProductSearchComponent from '../../../../common/search/simple-search-component';
import PageTitle from '../../../../common/page-title/index';
import ArrowButton from '../../../../common/button-arrow';
import {getBrands} from '../../../../../actions/brands';

import '../../common/styles.css';

class Brands extends Component {
  state = {
    query: ''
  };
  handleInputChange = (e) => {
    this.setState({query: e.target.value});
  };
  handleSearch = () => {
    const {query} = this.state;
    this.props.dispatch(getBrands(query));
  };
  handleClear = () => {
    this.setState({query: ''}, this.handleSearch);
  };

  UNSAFE_componentWillMount() {
    this.props.dispatch(actions.reset('deep.admin_brand'));
    this.props.dispatch({type: 'CLEAR_EDIT_BRAND'});
    this.props.dispatch(getBrands());
  }

  render() {
    return (
      <Container fluid className="products accordion">
        <PageTitle>
          Brands
        </PageTitle>
        <Link to="/admin/brands/new">
          <ArrowButton
            arrow={false}
            className="add-product"
            color="red"
            permissions={{
              action: 'create',
              subjectClass: 'Brand'
            }}
            submit={false}
          >
            Add brand
          </ArrowButton>
        </Link>

        <ProductSearchComponent
          onClear={this.handleClear}
          onInputChange={this.handleInputChange}
          onSearch={this.handleSearch}
          searchValue={this.state.query}
        />
        <BrandsList
          brands={this.props.brands}
          fetched={this.props.fetched}
          fetching={this.props.fetching}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  brands: state.brands.brands,
  fetched: state.brands.fetched,
  fetching: state.brands.fetching,
});

export default connect(mapStateToProps)(Brands);
